import { TemplateProductPricing } from "src/app/ui/models/domains/pbm/product-management/template-product-pricing";
import { AbstractParser } from "../../parser";
import { parseTemplateProductPricingList } from "./product-management-parse-funtions";

export class ProductPrincingTemplateParser extends AbstractParser<TemplateProductPricing[]> {
  public parse(payload: any): TemplateProductPricing[] {
    return parseTemplateProductPricingList(payload);
  }
}
